// Empty paragraphs look like this:
// <p data-marks="{font-size: 30}" style="font-size: 17px"><br></p>
//
// Since they don't have a text node and they have one child node, we have
// a special case that adds a text node to it so that we will measure it.
function isEmptyParagraph(node) {
  return (
    node.nodeName === 'P' &&
    node.childNodes.length === 1 &&
    node.childNodes[0].nodeName === 'BR'
  );
}

function addEmptyTextNodes(root) {
  var currentNode;
  var walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_ELEMENT,
    null,
    !1
  );

  if (isEmptyParagraph(root)) {
    root.appendChild(document.createTextNode(''));
  }

  while ((currentNode = walker.nextNode())) {
    const isEmptyP =
      currentNode.nodeName === 'P' && currentNode.childNodes.length === 0;
    const isMNode = currentNode.nodeName === 'M';
    const isFontNode = currentNode.nodeName === 'FONT';
    const isBodyNode = currentNode.nodeName === 'BODY';

    if (
      !isEmptyP &&
      ((!isMNode && !isFontNode && !isBodyNode) ||
        currentNode.childNodes.length !== 0)
    ) {
      continue;
    }

    currentNode.appendChild(document.createTextNode(''));
  }

  return root;
}

export function getTextNodesFromDOM(root: HTMLElement): Array<Text> {
  addEmptyTextNodes(root);

  var currentNode;
  var walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  var nodes = [];

  while ((currentNode = walker.nextNode())) {
    nodes.push(currentNode);
  }

  return nodes;
}
